import { createSlice } from "@reduxjs/toolkit";

const filterSlice = createSlice({
    name: "filter",
    initialState: {
        inCompleteFilter: [],
        completeFilter: [],
    },
    reducers: {
        inCompleteFilter: (state, { payload }) => {
            state.inCompleteFilter = payload
        },
        completeFilter: (state, { payload }) => {
            state.completeFilter = payload
        }
    }
})

export const { completeFilter, inCompleteFilter } = filterSlice.actions;
const filterReducer = filterSlice.reducer
export default filterReducer;